import { Component, OnInit, OnDestroy, NgZone } from "@angular/core";
import { Router } from "@angular/router";
import { UserService } from "../shared/services/user.service";
import { ViewStateService } from "../shared/services/view-state.service";
import { PurchaseStateService } from "./../purchase/shared/services/purchase-state.service";
import { AssessmentService } from "../assessment/shared/services/assessment.service";
import { CommonApiService } from "../shared/services/api/common-api.service";
import { NotificationsService } from "../shared/services/notifications.service";
import { WidgetState, CustomerData } from "@livechat/widget-core";
import { AppSettingsService } from "../shared/services/app-settings.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit, OnDestroy {
  username: string;
  personId: string;
  isCredentialed: boolean;
  isMenuOpen: boolean;
  isAssessment: boolean;
  instance: string;
  isBadge: boolean;
  isShowChat = false;
  agentsAvailable = false;
  isDirectory = false;
  isUnderNBRCJE = false;

  obj1 = { agents: true };

  isLiveChatWidgetLoaded = false;

  public visitor: { name: string; email: string };
  public params: Record<string, string>;
  private pendingChatOpen = false;

  private destroy$ = new Subject<void>();

  constructor(
    private userService: UserService,
    private viewState: ViewStateService,
    private appSettings: AppSettingsService,
    private assessmentService: AssessmentService,
    private notifications: NotificationsService,
    private router: Router,
    private purchaseState: PurchaseStateService,
    private commonApiService: CommonApiService,
    private ngZone: NgZone,
  ) {
    this.viewState.state$.pipe(takeUntil(this.destroy$)).subscribe((state) => {
      this.isMenuOpen = state.isMobileMenuOpen;
      this.isAssessment = state.isAssessment;
      this.isBadge = state.isBadge;
      this.constructHeader();
    });
  }

  ngOnInit() {
    //console.log('ONINIT',this.isLiveChatWidgetLoaded, this.liveChatWidget);
    this.lookForChatStatus();
  }

  showChat() {
    //this.LookForHoliday();
    return this.isShowChat;
  }

  toggleMobileMenu() {
    this.viewState.toggleMobileMenu();
  }

  private constructHeader(): void {
    const user = this.userService.CurrentUser;

    if (user) {
      this.setUsername(user);
      this.personId = user.personId;
      this.isUnderNBRCJE = user.underNBRCJE;
      this.isCredentialed = user.credentialHolder;
      this.instance = user.instance;
    } else {
      this.username = "";
    }

    // Directory check
    this.isDirectory = this.router.url.includes("directory");
    if (this.isDirectory) {
      this.isShowChat = false;
    }
  }

  private setUsername(user: {
    firstName: string;
    lastName: string;
    suffix?: string;
    middleName?: string;
  }): void {
    const parts = [
      user.firstName,
      user.middleName,
      user.lastName,
      user.suffix ? `, ${user.suffix}` : "",
    ].filter(Boolean);

    this.username = parts.join(" ");
  }

  get itemCount(): number {
    return this.purchaseState.currentItemCount;
  }

  AlphaOrBeta() {
    if (this.instance === "ALPHA" || this.instance === "BETA") {
      return true;
    }
    return false;
  }

  lookForChatStatus(): void {
    this.commonApiService
      .getChatStatus()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.isShowChat = res.practitionerPortalChatEnabled;
        },
        error: (err) => console.error("Error fetching chat status:", err),
      });
  }

  //checkAgents() {
  // this.liveChatApi.on_chat_state_changed = function(data) {
  //   alert("Chat state changed to: " + data.state);
  //   console.log(data.state);
  // }
  //    let x = this.liveChatWidget.onChatStateChanged
  //}

  blockCopy() {
    if (this.router.url.includes("assessment")) {
      this.assessmentService
        .warnUser(this.personId, "copy")
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (_res) => {
            this.notifications.errorWithWait(
              "Warning",
              "Your key strokes are recorded by the system. Efforts to capture content could initiate an investigation of potential misconduct by the NBRC Judicial and Ethics Committee.",
              0,
            );
          },
          (err) => {
            console.error(err);
          },
        );
    }
  }

  blockCut() {
    if (this.router.url.includes("assessment")) {
      this.assessmentService
        .warnUser(this.personId, "cut")
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (_res) => {
            this.notifications.errorWithWait(
              "Warning",
              "Your key strokes are recorded by the system. Efforts to capture content could initiate an investigation of potential misconduct by the NBRC Judicial and Ethics Committee.",
              0,
            );
          },
          (err) => {
            console.error(err);
          },
        );
    }
  }

  onStateChanged(event): void {
    this.ngZone.run(() => {
      if (event.state === "offline") {
        this.agentsAvailable = false;
      } else {
        this.agentsAvailable = true;
      }
      //console.log(this.agentsAvailable);
      Object.defineProperty(this.obj1, "agents", {
        value: this.agentsAvailable,
        writable: true,
      });
    });
  }

  agentsAvailableFnc() {
    this.agentsAvailable = this.obj1.agents;
    //console.log('agentsAvailableFnc' + this.agentsAvailable);
    return this.agentsAvailable;
  }

  onAvailabilityChanged(event: Pick<WidgetState, "availability">): void {
    this.ngZone.run(() => {
      this.agentsAvailable = event.availability !== "offline";
    });
  }

  openChatWindow(): void {
    //console.log("Chat button clicked");

    const currentUser = this.userService.CurrentUser;
    if (!currentUser) {
      return;
    }

    // Build visitor
    this.visitor = {
      name: this.username,
      email: currentUser.email,
    };
    //console.log("Visitor:", this.visitor);

    // Determine status
    const statusMap: Record<string, string> = {
      "A|true": "ACTIVE CMP",
      "I|true": "INACTIVE CMP",
      "A|false": "ACTIVE SUPPORT",
      "I|false": "INACTIVE SUPPORT",
      "S|false": "ACTIVE SUPPORT",
    };
    const statusInfo =
      statusMap[`${currentUser.status}|${currentUser.subjectToCMP}`] ||
      "Inactive";

    // Build session variables
    this.params = {
      PersonId: String(this.personId),
      Status: statusInfo,
      Link: `${this.appSettings.InternalUIBase}person/${this.personId}`,
    };
    //console.log("Params:", this.params);

    // Open immediately if widget ready, otherwise mark pending
    if (this.isLiveChatWidgetLoaded && (window as any).LC_API) {
      //console.log("Calling LC_API.open_chat_window()");
      (window as any).LC_API.open_chat_window();
    } else {
      //console.log("Widget not ready yet, marking pending");
      this.pendingChatOpen = true;
    }
  }

  onWidgetReady(_event: {
    state: WidgetState;
    customerData: CustomerData;
  }): void {
    //console.log("Widget Ready Event Fired!", event);
    this.isLiveChatWidgetLoaded = true;

    if (this.pendingChatOpen && (window as any).LC_API) {
      //console.log("Pending chat open, calling LC_API.open_chat_window()");
      (window as any).LC_API.open_chat_window();
      this.pendingChatOpen = false;
    }
  }

  hideChatWindow(): void {
    if ((window as any).LC_API) {
      (window as any).LC_API.minimize_chat_window();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
